import Vue from "vue";
import ForgotPassword from "./ForgotPassword.vue";
import textFieldVue from "../../components/v-components/input-text.vue";
import modal from "../../components/v-components/modal.vue";

Vue.component("v-input-text", textFieldVue);
Vue.component("v-modal", modal);


Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            // here I check that click was outside the el and his children
            if (!(el == event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                binding.value(event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
    },
});

Vue.prototype.$eventBus = new Vue();

new Vue({
    el: "#forgot-password",
    components: {
        ForgotPassword
    }
});



// WEBPACK FOOTER //
// ./modules/forgot-password/index.js